module.exports = __webpack_public_path__ + "img/form-banner-tablet.63719176.png";